module.exports = __webpack_public_path__ + "static/media/fichaAHW.b68671a7.pdf";